import React, { Component } from 'react';
import img4 from '../../../img/bsl/4.jpg';
import img0 from '../../../img/bsl/0.jpg';

class Error404 extends Component {
  render () {
    return (
      <main className='main'>
        <div className='l-container'>
          <p className='u-text-center'>
            <img src={img4} alt='4' />
            <img src={img0} alt='0' />
            <img src={img4} alt='4' />
          </p>
          <h1 className='u-text-center'>Sorry! But the page you are looking for cannot be&nbsp;found</h1>
          <div className='l-container l-container--x-narrow'>
            <p>This might be because:</p>
            <ul className='bullet-list'>
              <li>You have typed the web address incorrectly, or</li>
              <li>you came here form an external link that is incorrect or out of date, or</li>
              <li>the page you were looking for may have been moved, updated or deleted.</li>
            </ul>
            <p><strong>Please try the following options instead:</strong></p>
            <ul className='bullet-list'>
              <li><a href='/'>Go back to the home page</a> and start over, or</li>
              <li><a href='/contact'>Contact us</a> if the problem persists</li>
            </ul>
          </div>
        </div>
      </main>
    );
  }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/views/Main/Error404/index.js